import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const RoundEmptyStar: FunctionalComponent<IIconProps> = ({ width = '12', height = '13', fill = '#CCCCCC' }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.39347 10.3C6.14632 10.1739 5.85368 10.1739 5.60653 10.3L3.20135 11.5273C2.56477 11.8521 1.83103 11.3093 1.95539 10.6055L2.40198 8.07834C2.45263 7.79173 2.35587 7.49886 2.14444 7.29883L0.271702 5.52707C-0.255087 5.02868 0.0276776 4.14227 0.745757 4.041L3.38002 3.66948C3.6598 3.63002 3.90272 3.45651 4.03079 3.20465L5.22834 0.849534C5.54924 0.218449 6.45077 0.21845 6.77167 0.849535L7.96921 3.20465C8.09728 3.45651 8.3402 3.63002 8.61998 3.66948L11.2542 4.041C11.9723 4.14227 12.2551 5.02868 11.7283 5.52707L9.85556 7.29883C9.64414 7.49886 9.54737 7.79173 9.59802 8.07834L10.0446 10.6055C10.169 11.3093 9.43523 11.8521 8.79865 11.5273L6.39347 10.3Z"
        fill={fill}
      />
    </svg>
  );
};

export default RoundEmptyStar;
